/**
 * journey Group
 * @param fb : FormBuilder
 */
export function journeyGroup(fb: any): any {
    return fb.group({
        carrier: fb.control([]),
        from: fb.control(''),
        to: fb.control(''),
        begin: fb.group({
            min: fb.control(''),
            max: fb.control('')
        }),
        end: fb.group({
            min: fb.control(''),
            max: fb.control('')
        }),
        direction: fb.control([]),
        isOpen: fb.control([]),
        includeMirrors: fb.control(''),
        references: fb.control([])
    });
}


/**
 * journey Group for model
 * @param fb : FormBuilder
 */
export function journeyModelGroup(fb: any): any {
    return fb.group({
        from: fb.control(''),
        to: fb.control(''),
        direction: fb.control([])
    });
}
